import commonApi from './CommonApi.js';

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/admin/keywords/getAll', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/v1/admin/keywords/getById', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	create: async (viewModel) => {
		return await commonApi().post('/v1/admin/keywords', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/admin/keywords', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/admin/keywords', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getForDropdown: async (parameter) => {
		return await commonApi().get('/v1/keywords/getForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getForSearchDropdown: async (parameter) => {
		return await commonApi().get('/v1/keywords/getForSearchDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getForTBTSearchDropdown: async (parameter) => {
		return await commonApi().get('/v1/keywords/getForTBTSearchDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	}
}